import React from 'react';

/**
 * Skip Navigation Link - Allows keyboard/screen reader users to skip to main content
 * WCAG 2.1 Level A - Bypass Blocks (2.4.1)
 */
export const SkipNavigation = () => {
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-primary focus:text-primary-foreground focus:rounded-md focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 transition-all"
      aria-label="Skip to main content"
    >
      Skip to main content
    </a>
  );
};
